<template>
    <div v-show="visible">
        <el-dialog title="添加" :close-on-click-modal="false" 
            v-loading="loading"
            element-loading-background = "rgba(255, 255,255,0.7)"
            element-loading-text = "保存中..."
            :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-form-item  prop="groupName" label="小组名称">
                        <el-input v-model="form.groupName" maxlength="15" style="width:200px;"></el-input>
                    </el-form-item>
                    
                    <el-form-item prop="" label="绑定学生">
                        <el-input placeholder="请选择人名" :readonly="true" v-model="form.bindUseridsLabel" style="width:200px;" class="input-with-select">
                            <el-button slot="append" icon="el-icon-search" @click="findUser()"></el-button>
                        </el-input>
                    </el-form-item>

                    <el-form-item   prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" max="999" type="number" style="width:200px;"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
         <!-- 人员弹出框 -->
        <div v-if="userTransferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../../common/http';
    import userTransfer from './UserTransfer.vue';

    export default {
        data(){
            return{
                userTransferVisible:false,
                visible: false,
                loading:false,
                form:{
                    groupSchemeId:"",
                    userId:"",
                    classId:"",
                    groupName:"",
                    bindUseridsLabel:"",
                    orderNum:1,
                },
                userIds:[],
                userIdsLabel:[],
                rules: {
                    groupName: [
                        { required: true, message: '请输入小组名称', trigger: 'blur' }
                    ],
                    orderNum: [
                        { required: true, message: '请输入排序号', trigger: 'blur' }
                    ]
                }
            }
        },
        components: {
            userTransfer
        },
        created:function () {
        },
        methods:{
            init(data, groupSchemeId, userId, classId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }

                this.form.userId = userId;
                this.form.classId = classId;
                this.form.groupSchemeId = groupSchemeId;

                // 初始排序号
                if(data.length == 0){
                    this.form.orderNum =1;
                }else{
                    let rowData=data[data.length-1];
                    this.form.orderNum = rowData.orderNum+1;
                }
                // 初始值
                this.userIds=[];
                this.userIdsLabel=[];
                this.form.bindUseridsLabel="";

            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        if(this.userIds.length == 0){
                            this.$commonFn.showTip('绑定学生不可为空',3);
                            return;
                        }
                        let url= this.setClassBindGroupSavePCUrl;
                        let data = {
                            groupSchemeId:this.form.groupSchemeId,
                            userId:this.form.userId,
                            classId:this.form.classId,
                            groupName:this.form.groupName,
                            bindUserIds:this.userIds.join(','),
                            orderNum:this.form.orderNum,
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.loading=true;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getClassGroupData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            },
            findUser(){
                this.userTransferVisible=true;
                this.$nextTick(() => { 
                    if(this.$util.isNotEmpty(this.form.bindUseridsLabel)){
                        this.$refs['userTransfer'].init(1,this.userIds,2,this.form.classId,this.form.userId,this.form.groupSchemeId);
                    }else{
                        this.$refs['userTransfer'].init(1,null,2,this.form.classId,this.form.userId,this.form.groupSchemeId);
                    }
                })
            },
            setUser(key,label){
                this.userIds = key;
                this.userIdsLabel = label;
                this.form.bindUseridsLabel = label.join(',');
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/set/classroomtime/group/addClassGroup.vue